import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor } from '../../../util/theme';

const ProgramFeaturesWrapper = styled.section`
  background-color: ${getColor('lightGrey')};

  border-bottom: 10px solid ${getColor('medGrey')};
  border-top: 10px solid ${getColor('medGrey')};

  padding: 0 0 25px 0;

  h1 {
    margin: 25px 0;

    @media (min-width: ${getBreakpoint('xl')}) {
      margin: 0 0 50px 0;
      padding: 0 0 0 calc(20% + 15px);
    }
  }
`;

export default ProgramFeaturesWrapper;
